import { render, staticRenderFns } from "./CashupSummary.vue?vue&type=template&id=3b5dc978&scoped=true"
import script from "./CashupSummary.vue?vue&type=script&lang=js"
export * from "./CashupSummary.vue?vue&type=script&lang=js"
import style0 from "./CashupSummary.vue?vue&type=style&index=0&id=3b5dc978&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5dc978",
  null
  
)

export default component.exports